// @noflow
import { Button, Modal } from '~/components/widgets';

import { Buttons } from './style';
import { FormattedMessage } from 'react-intl';
import messages from './intl';
import * as React from 'react';

export default ({ isOpen, setAsHumidifier, setAsDeHumidifier }) => {
    return (
        <Modal contentLabel="Humidity control modal" isOpen={isOpen}>
            <h2>
                <FormattedMessage {...messages.popupTitle} />
            </h2>
            <p>
                <FormattedMessage {...messages.popupQuestion} />
            </p>
            <Buttons>
                <li>
                    <Button onClick={setAsHumidifier}>
                        <FormattedMessage {...messages.humidifier} />
                    </Button>
                </li>
                <li>
                    <Button onClick={setAsDeHumidifier}>
                        <FormattedMessage {...messages.dehumidifier} />
                    </Button>
                </li>
            </Buttons>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/humidity-control-modal/component.js